module.exports = __webpack_public_path__ + "static/media/Tag_Box.935b85b6.svg";